import { ApiCall } from '../apiCall';

export type FmsApiCall = ApiCall;

export function createApiCall(apiCall: ApiCall, baseUrl: string): ApiCall {
    return <T>(url: string, options?: RequestInit | undefined) => {
        return apiCall<T>(baseUrl + url, options);
    };
}
